/* tslint:disable */
/* eslint-disable */
/**
 * kms-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 * @enum {string}
 */
export var UserPolicyOneOfTypeEnum;
(function (UserPolicyOneOfTypeEnum) {
    UserPolicyOneOfTypeEnum["root"] = "ROOT";
})(UserPolicyOneOfTypeEnum || (UserPolicyOneOfTypeEnum = {}));
